import {createSettingsParams} from '@wix/tpa-settings';

export type ISettingsParams = {};
export default createSettingsParams<ISettingsParams>({});
export function getFreeTextKeys() {
  return [];
}
